import * as storage from 'client/javascript/storage';
import { localizeLink } from 'client/javascript/util/locale';
import { getSelectedLocation, getLocationDropdownSelectedId } from './utils';
import { setupWizardTrackingEvents } from './tracking';

const SELECT_LOCATION_BTN = 'select-location-btn';

function getMarketPageUrl() {
  const selectedLocation = getSelectedLocation();
  const marketPath = selectedLocation.getAttribute('data-market-path');
  const marketSlug = marketPath.replace('/l/', '');
  const searchPageWithParams = `/search?slug=${marketSlug}`;

  return localizeLink({ to: searchPageWithParams });
}

function handleSelectLocation(evt) {
  evt.preventDefault();
  const locationDropdownId = getLocationDropdownSelectedId();
  storage.setLocationId(locationDropdownId);
  window.location = getMarketPageUrl();
}

export default function setupWizard() {
  const selectLocationEl = document.getElementById(SELECT_LOCATION_BTN);

  if (selectLocationEl) {
    selectLocationEl.addEventListener('click', handleSelectLocation);
    setupWizardTrackingEvents();
  }
}
